import React, { useCallback, useContext, useRef } from 'react';
import { ToggleSwitch, SingleSelectGroup } from '@xo-union/tk-component-switches';
import { Subtle, Caption } from '@xo-union/tk-ui-typography';
import { useUpdateConversationalAiSettingsMutation, useWeddingWebsiteQuery } from '../../generated/graphql';
import { weddingWebsiteQuery } from '../Dashboard';
import styles from './AiSettingsPanel.scss';
import Alert from '@xo-union/tk-component-alerts';
import { TrackingContext } from '../../TrackingContext';

export const AiSettingsPanel: React.FC = () => {
  const { track } = useContext(TrackingContext);

  const alertRef = useRef<any>(null);
  const showAndDismissAlert = useCallback((message: string) => {
    alertRef.current.showAndDismiss({
      type: 'error',
      content: message,
      waitTime: 10000,
    });
  }, []);
  const { data } = useWeddingWebsiteQuery();
  const conversationalMemoryEnabled = !!data?.member?.aiSettings?.useConversationalMemory;
  const [mutateAiSettings, { loading: updatingMemorySettings }] = useUpdateConversationalAiSettingsMutation();
  const onToggleConversationalMemory = async () => {
    try {
      track('CTA Clicked', {
        action: conversationalMemoryEnabled ? 'memory_toggle_off' : 'memory_toggle_on',
        selection: 'memory_toggle',
        sourcePage: 'wws_AI_assistant',
        location: 'wws_ai_assistant',
      });
      await mutateAiSettings({
        variables: {
          args: {
            useConversationalMemory: !conversationalMemoryEnabled,
          },
        },
        update: (cache, response) => {
          cache.writeQuery({
            query: weddingWebsiteQuery,
            data: {
              ...data,
              member: {
                ...data?.member,
                aiSettings: {
                  ...data?.member?.aiSettings,
                  useConversationalMemory: response?.data?.updateConversationalAiSettings!!,
                },
              },
            },
          });
        },
      });
    } catch (error) {
      showAndDismissAlert('Failed to update AI settings. Please try again.');
    }
  };
  return (
    <div className={styles['ai-settings-item-container']}>
      <SingleSelectGroup
        disabled={updatingMemorySettings}
        onValueChange={onToggleConversationalMemory}
        value={conversationalMemoryEnabled ? 'memory-on' : 'memory-off'}
      >
        <ToggleSwitch value="memory-on">Use conversational memory</ToggleSwitch>
        <Subtle className="caption-lg">
          <Caption size="lg">Let Quinn remember details from past conversations for personalized responses.</Caption>
          <Caption size="lg">The Knot doesn't use the content provide here to train its models.</Caption>
        </Subtle>
      </SingleSelectGroup>
      <Alert ref={alertRef} position="top" />
    </div>
  );
};
